import Box from '@mui/material/Box'
import type { PaymentOrderV2 } from '@mynt/backoffice-api-spec/payment'
import { useState } from 'react'
import { usePaymentOrders } from '../../api/react-query'
import useMaterialNotification from '../../hooks/useMaterialNotification'
import FigmaBox from '../../mynt-components/components/FigmaBox'
import { MarkAmlApprovedAction } from './actions'
import { OutboundPaymentsTable } from './OutboundPaymentsTable'

export const OutboundPayments = () => {
  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 25 })

  const { data, isLoading } = usePaymentOrders({
    page: paginationModel.page + 1,
    pageSize: paginationModel.pageSize,
  })

  const notify = useMaterialNotification()

  const rowCount = data?.pagination?.totalItems ?? 0

  const tableActions = (paymentOrder: PaymentOrderV2, onClose: () => unknown) => [
    <MarkAmlApprovedAction
      key="mark-aml-approved"
      paymentOrder={paymentOrder}
      onSuccess={() => {
        onClose()
        notify('Marked AML check as approved')
      }}
    />,
  ]

  return (
    <FigmaBox fullWidth>
      <h2>Outbound Payments</h2>
      <Box sx={{ maxWidth: '93vw' }}>
        <OutboundPaymentsTable
          paymentOrders={data?.data ?? []}
          isLoading={isLoading}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          rowCount={rowCount}
          actions={tableActions}
        />
      </Box>
    </FigmaBox>
  )
}
